interface Window {
  clickToCTA: (url: string) => void;
}

window.addEventListener("DOMContentLoaded", () => {
  if (window.top !== window.self) {
    const sectionsToHide = document.querySelectorAll("body > *:not(#hero)");
    console.log(sectionsToHide);
    document.body.style.overflow = "hidden";
    console.log(
      Array.from(sectionsToHide).filter((section) => {
        console.log(section.id);
        return section.id !== "features";
      }),
    );
    Array.from(sectionsToHide)
      .filter((section) => {
        console.log(section.id);
        return section.id !== "features";
      })
      .filter((section) => {
        console.log(section.id);
        return section.id !== "promotionTimer";
      })
      .forEach((section) => {
        (section as HTMLElement).style.display = "none";
      });
  }
  const hero = document.getElementById("hero");
  const features = document.getElementById("features");
  const promotionTimer = document.getElementById("promotionTimer");

  window.addEventListener("resize", () => {
    window.parent.postMessage(
      {
        type: "resize",
        height:
          (hero?.scrollHeight || 0) +
          (features?.scrollHeight || 0) +
          (promotionTimer?.scrollHeight || 0),
      },
      "*",
    );
  });

  window.parent.postMessage(
    {
      type: "resize",
      height:
        (hero?.scrollHeight || 0) +
        (features?.scrollHeight || 0) +
        (promotionTimer?.scrollHeight || 0),
    },
    "*",
  );
  setTimeout(() => {
    window.parent.postMessage(
      {
        type: "resize",
        height:
          (hero?.scrollHeight || 0) +
          (features?.scrollHeight || 0) +
          (promotionTimer?.scrollHeight || 0),
      },
      "*",
    );
  }, 1000);

  window.clickToCTA = function (url: string) {
    window.parent.postMessage({ type: "cta", url }, "*");
  };
});
